export default function Tab(props){
  const selected = 'bg-sky-600 text-white';
  const notSelected='bg-gray-100 text-black border border-gray-300';

  let display = 'flex';
  if(props.showAll === false){
    if(!props.selected) display="hidden";
  }

  return (
    <div className={`${props.className} px-10 py-4  ${display} lg:flex flex-row justify-between ${props.selected? selected:notSelected}`} >
      <div onClick={props.selectCallback} className="flex justify-center grow"><p className="">{props.tab}</p></div>
      <div className={`lg:hidden`} onClick={props.showAllCallback}>
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" 
          viewBox="0 -960 960 960" width="24px" fill={`${props.selected? "#FFFFFF":"#FFFFFF00"} `}>
          <path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z"/>
        </svg>
      </div>
    </div>
  );
}